// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".musicianTrackItemHeader_root__3Km_l {\n  display: grid;\n  grid-template-columns: 40px 1.5fr 1.5fr 100px 1.5fr 1fr; }\n  .musicianTrackItemHeader_root__3Km_l .musicianTrackItemHeader_item__3_Q0a {\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    color: #464646; }\n", ""]);
// Exports
exports.locals = {
	"root": "musicianTrackItemHeader_root__3Km_l",
	"item": "musicianTrackItemHeader_item__3_Q0a"
};
module.exports = exports;
